<template>
  <div class="select-input">
    <label class="b-block mb-2" :for="id">
      {{ label }}
      <button v-if="modalIdentifier" class="btn--reset" type="button" @click="onModalOpen" tabindex="-1">
        <icon identifier="info" />
        <span class="sr-only">Open pop-up</span>
      </button>
    </label>

    <div class="custom-select">
      <select
        :name="id"
        :id="id"
        :value="value"
        @change="$emit('change', $event)"
        required
      >
        <option :value="option.value" v-for="option in options" :key="option.value">
          {{ option.title }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon';
import InfoTooltip from '../InfoTooltip';

export default {
  components: {
    Icon,
    InfoTooltip,
  },

  props: {
    id: String,
    label: String,
    options: Array,
    value: [String, Number],
    modalIdentifier: String,
  },

  computed: {
    modal() {
      if (!this.modalIdentifier) {
        return null;
      }

      return this.$store.getters.modalForIdentifier(this.modalIdentifier);
    },
  },

  methods: {
    onModalOpen() {
      this.$store.commit('setModalTitle', this.modal.title);
      this.$store.commit('setModalContent', this.modal.content);
      this.$store.commit('setModalOpen', true);
    },
  },
};
</script>

<style scoped>
.select-input :global(svg) {
  width: 1em;
  height: 1em;
  fill: #867253;
}
</style>
